import TNTControlBase from '../../util/TNTControlBase';

class ShiptypeController extends TNTControlBase {
  /*@ngInject*/
  constructor($state) {
    super();
    this.acl = {}
    this.hasACL = {}
    this.id = 'shiptype'
    this.$state = $state

  }
  $onInit() {
    super.$onInit()
    for (let key in this.acl['tnt_control_' + this.id]) {
      this.hasACL[this.acl['tnt_control_' + this.id][key]] = true;
    }
  }
}

export default ShiptypeController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/shiptype/shiptype.controller.js